import { render, staticRenderFns } from "./FNAC.vue?vue&type=template&id=0908cea4&scoped=true&"
import script from "./FNAC.vue?vue&type=script&lang=js&"
export * from "./FNAC.vue?vue&type=script&lang=js&"
import style0 from "./FNAC.vue?vue&type=style&index=0&id=0908cea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0908cea4",
  null
  
)

export default component.exports